// src/services/saasService.js
import api from "./api";
const qs = (p={}) => new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)).toString();

const saasService = {
  // Clientes
  listarClientes:       (p={}) => api("GET", `/saas/clientes?${qs(p)}`),
  buscarCliente:        (id)   => api("GET", `/saas/clientes/${id}`),
  criarCliente:         (data) => api("POST","/saas/clientes", data),
  atualizarCliente:     (id,data) => api("PUT", `/saas/clientes/${id}`, data),
  alterarStatus:        (id,data) => api("PATCH",`/saas/clientes/${id}/status`, data),
  estenderVencimento:   (id,data) => api("PATCH",`/saas/clientes/${id}/vencimento`, data),

  // Planos
  listarPlanos:         (p={}) => api("GET", `/saas/planos?${qs(p)}`),
  listarModulos:        ()     => api("GET", "/saas/modulos"),
  buscarPlano:          (id)   => api("GET", `/saas/planos/${id}`),
  criarPlano:           (data) => api("POST","/saas/planos", data),
  atualizarPlano:       (id,data) => api("PUT",`/saas/planos/${id}`, data),
  deletarPlano:         (id)   => api("DELETE",`/saas/planos/${id}`),

  // Dashboard SaaS
  saasStats:            ()     => api("GET", "/saas/stats"),

  // Módulos do plano do tenant logado
  modulosTenant:        ()     => api("GET", "/planos/modulos-tenant"),
};

export default saasService;
